module.exports = __webpack_public_path__ + "static/media/illu-tuto-04.a08ddff5.svg";